











































































































































































































import Vue from "vue";
import Api from "@/api/api";
import Catasto from "@/data/catasto";
import ConsentGroupOverview from "@/api/models/ConsentGroupOverview";
import Customer from "@/api/models/Customer";
import CustomerComplianceStatus from "@/api/models/CustomerComplianceStatus";
import DocOverview from "@/api/models/DocOverview";
import Locale from "@/data/locale";
import moment from "moment";
import { TipoCliente, TipoClienteArray } from "@/entities/tipo-cliente";
import ConsentGroup from "@/components/ConsentGroup.vue";

interface Data {
  complianceStatus?: CustomerComplianceStatus;
  consentGroups: Array<ConsentGroupOverview>;
  customer?: Customer;
  docOverviews: Array<DocOverview>;
  localeIt: {
    days: Array<string>;
    daysShort: Array<string>;
    months: Array<string>;
    monthsShort: Array<string>;
  };

  loaded: boolean;
  tipi: Array<{
    label: TipoCliente;
    value: string;
  }>;
}

export default Vue.extend({
  props: ["id"],
  data(): Data {
    return {
      consentGroups: [],
      customer: undefined,
      docOverviews: [],
      localeIt: Locale.QInputDateLocaleIt,
      loaded: false,
      tipi: TipoClienteArray
    };
  },

  computed: {
    fullAddress(): string | undefined {
      if (!this.customer) return;

      const toponym = this.customer.toponym;
      const address = this.customer.address;
      const civic = this.customer.civic_number;
      const cap = this.customer.cap;
      const comune = this.customer.comune;
      const province = this.customer.province;

      return `${toponym} ${address} ${civic} ${cap} ${comune} (${province})`;
    },

    getBirthPlace(): string | undefined {
      if (!this.customer) return;

      return Catasto.searchByCode(this.customer.birthplace)[0].description;
    },

    getType(): string | undefined {
      if (!this.customer) return;

      switch (this.customer.type) {
        case "M":
          return "Maschio";
        case "F":
          return "Femmina";
        case "D":
          return "Ditta";
        default:
          return "Sconosciuto";
      }
    },

    emailOverview(): DocOverview {
      return this.docOverviews.filter(overview => overview.slug === "email")[0];
    },

    privacyOverview(): DocOverview {
      return this.docOverviews.filter(
        overview => overview.slug === "privacy"
      )[0];
    },

    sevenAOverview(): DocOverview {
      return this.docOverviews.filter(overview => overview.slug === "7A")[0];
    },

    sevenBOverview(): DocOverview {
      return this.docOverviews.filter(overview => overview.slug === "7B")[0];
    }
  },
  methods: {
    onCustomerTypeChange($event: any) {
      if (this.customer) {
        this.customer.type = $event.value;
      }
    },

    onCustomerBirthPlaceChange($value: any) {
      if (!this.customer) return;

      const risultatiCatasto = Catasto.search($value);
      if (risultatiCatasto.length === 1) {
        this.customer.birthplace = risultatiCatasto[0].code;
        return risultatiCatasto[0].description;
      }
    },

    setSex(): string | undefined {
      if (!this.customer) return;

      switch (this.customer.type) {
        case "M":
          return "Maschio";
        case "F":
          return "Femmina";
        case "D":
          return "Ditta";
        default:
          return "Sconosciuto";
      }
    },

    async updateCustomer(): Promise<void> {
      if (!this.customer) return;

      this.$q.loading.show();
      // TODO: fare per benino.
      const risultatiCatasto = Catasto.searchByCode(this.customer.birthplace);

      if (risultatiCatasto.length === 0) {
        this.$q.notify({
          progress: true,
          message: `Luogo di nascita non valido, nessun comune trovato per "${this.customer.birthplace}"`,
          type: "negative"
        });
        this.$q.loading.hide();
        return;
      }

      const codiceCatastaleNascita = risultatiCatasto[0].code;

      const creationResult = await Api.customer.updateCustomerAsync(
        this.customer.id,
        {
          /* eslint-disable */
          toponym: this.customer.toponym,
          address: this.customer.address,
          civic_number: this.customer.civic_number,
          cap: this.customer.cap,
          comune: this.customer.comune,
          province: this.customer.province,
          nation: this.customer.nation,
          email: this.customer.email,
          mobile_phone: this.customer.mobile_phone,
          fixed_phone: this.customer.fixed_phone,
          note: this.customer.note,
          type: this.customer.type,
          lastname: this.customer.lastname,
          firstname: this.customer.firstname,
          description: this.customer.firstname + " " + this.customer.lastname,
          fiscal_code: this.customer.fiscal_code,
          piva: this.customer.piva,
          birthplace: codiceCatastaleNascita,
          birthday: this.customer.birthday
          /* eslint-enable */
        }
      );

      // Se ha la proprietà "id" è andato ben e c'è il cliente,
      // altrimenti c'è stato un qualche errore.
      if (!creationResult.error && creationResult.id) {
        /*
        const message = "Modifica effettuata correttamente";

        this.$q.notify({
          progress: true,
          message: message,
          type: "positive"
        });
        */
        this.$router.go(0);
      } else {
        const message =
          creationResult.message ||
          "Si è verificato un errore, riprovare. (codice errore: " +
            creationResult.error +
            ")";

        this.$q.notify({
          progress: true,
          message: message,
          type: "negative"
        });

        // Se è ha errore multipli o di validazione, uno per volta si mostrano.
        if (creationResult.errors) {
          for (const error of creationResult.errors) {
            this.$q.notify({
              progress: true,
              message: error,
              type: "negative"
            });
          }
        }
      }

      this.$q.loading.hide();
    },
    formatDate(value: string) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    isComplianceStatus(obj: any) {
      return obj.compliance && obj.code !== "CA";
    },
    isComplianceWarningStatus(obj: any) {
      return obj.code === "CA";
    },
    isWaitingStatus(obj: any) {
      return (
        obj.code === "FC" ||
        obj.code === "SS" ||
        obj.code === "AC" ||
        obj.code === "VC"
      );
    },
    getAllowReceiveEmail(obj: any) {
      return obj.allow_receive_email == null ? true : obj.allow_receive_email;
    },
    setStatusIcon(objStatus: any, slug: any, block: any) {
      if (this.isComplianceStatus(objStatus)) {
        return (
          "/img/icons/documents/" +
          slug +
          "_green" +
          (slug === "email" && block ? "_block" : "") +
          ".png"
        );
      } else if (this.isWaitingStatus(objStatus)) {
        return (
          "/img/icons/documents/" +
          slug +
          "_yellow" +
          (slug === "email" && block ? "_block" : "") +
          ".png"
        );
      } else if (this.isComplianceWarningStatus(objStatus)) {
        return (
          "/img/icons/documents/" +
          slug +
          "_green_warn" +
          (slug === "email" && block ? "_block" : "") +
          ".png"
        );
      } else {
        return (
          "/img/icons/documents/" +
          slug +
          "_red" +
          (slug === "email" && block ? "_block" : "") +
          ".png"
        );
      }
    }
  },
  async mounted() {
    this.$q.loading.show();

    try {
      const detail = await Api.customer.getDetailAsync(this.id);

      this.customer = detail.customer;
      this.docOverviews = detail.doc_overviews;
      this.complianceStatus = this.customer.customer_compliance_status;
      this.consentGroups = detail.consent_group_overviews;
      /* Todo DECOMMENT WHEN STARTING SIDEBAR DEVELOPMENT
    const getInfoResult = await Api.anima.getInfoAsync({
      tipo: "updateonly",
      items: [
        {
          Tipo: this.customer.type,
          Nome: this.customer.firstname,
          Cognome: this.customer.lastname,
          Descrizione: this.customer.description,
          CodiceFiscale: this.customer.fiscal_code,
          DataNascita: this.customer.birthday,
          ComuneNascita: this.customer.birthplace,
          Toponimo: this.customer.toponym,
          NumeroCivico: this.customer.civic_number,
          Indirizzo: this.customer.address,
          CAP: this.customer.cap,
          Comune: this.customer.comune,
          Localita: "",
          Provincia: this.customer.province,
          Email: this.customer.email,
          Cellulare: this.customer.mobile_phone,
          Telefono: this.customer.fixed_phone,
          CodiceProduttore: this.customer.producer_code
        }
      ],
      credentials: {
        apiKey: "FAuxwdtOOlxVRDml5gaqhcs5X8aOch",
        username: "superadmin",
        dominio: "gaat"
      }
    });
    */
    } catch {
      this.customer = undefined;
      this.docOverviews = [];
      this.complianceStatus = undefined;
      this.consentGroups = [];
    } finally {
      this.loaded = true;
      this.$q.loading.hide();
    }
  }
});
